module.exports = __webpack_public_path__ + "static/media/42x38-13.893b0780.png";